<template>
  <v-container class="text-center">
    <v-row>
      <v-col cols="12" md="10" offset-md="1">
        <h1>
          Did you know that {{ whitelabel.name }} can be appointed as the
          Executor of your estate*?
        </h1>
      </v-col>
    </v-row>

    <v-row>
      <v-col cols="12" md="5" class="pt-0">
        <v-img
          :src="require(`@/assets/${whitelabel.images.executorExplainerMain}`)"
          aspect-ratio="1"
          alt="Executor"
          max-width="340"
          class="mx-auto"
        />
      </v-col>
      <v-col cols="12" md="7">
        <h2 class="text-left mb-4 mt-md-13">
          Why should you appoint {{ whitelabel.name }} as your Executor?
        </h2>
        <ul class="why-appoint-us-list">
          <li>
            we are open to negotiation regarding Executor fee when estate value
            reaches a certain threshold
          </li>
          <li>
            reduced property transfer costs for estates / properties over a
            certain threshold
          </li>
          <li>full transparency during administration process</li>
          <li>
            open to helping appoint Executors (sometimes financial advisors) on
            a fee sharing basis
          </li>
        </ul>
        <p class="mt-5 text-left">
          *QuickWill administers estates through Online Wills Estate
          Administrators.
        </p>
      </v-col>
    </v-row>
    <v-row class="mt-4">
      <v-col cols="12">
        <h2>How does it work?</h2>
      </v-col>
      <v-col cols="12" sm="6" md="2" offset-md="2">
        <v-img
          :src="
            require(`@/assets/${whitelabel.images.executorExplainerHowDoesItWork1}`)
          "
          aspect-ratio="1"
          alt="possession of will"
          max-width="160"
          class="mx-auto"
        />
        <p>
          Testator and/or their financial advisor ensures that
          {{ whitelabel.name }} gets possession of the originally signed will
        </p>
      </v-col>
      <v-col cols="12" sm="6" md="2">
        <v-img
          :src="
            require(`@/assets/${whitelabel.images.executorExplainerHowDoesItWork2}`)
          "
          aspect-ratio="1"
          alt="advised of passing"
          max-width="160"
          class="mx-auto"
        />
        <p>
          {{ whitelabel.name }} gets advised by family/financial advisor of
          testator's passing
        </p>
      </v-col>
      <v-col cols="12" sm="6" md="2">
        <v-img
          :src="
            require(`@/assets/${whitelabel.images.executorExplainerHowDoesItWork3}`)
          "
          aspect-ratio="1"
          alt="completes documents"
          max-width="160"
          class="mx-auto"
        />
        <p>
          {{ whitelabel.name }} completes documents and reports deceased estate
          to Master's office
        </p>
      </v-col>
      <v-col cols="12" sm="6" md="2">
        <v-img
          :src="
            require(`@/assets/${whitelabel.images.executorExplainerHowDoesItWork4}`)
          "
          aspect-ratio="1"
          alt="administration"
          max-width="160"
          class="mx-auto"
        />
        <p>
          {{ whitelabel.name }} receives letters of executorship from Master's
          office and commences with the administration of the deceased estate
        </p>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
  export default {
    name: 'ExecutorExplainer',
    computed: {
      draftMyWillRedirectLocation() {
        return this.isLoggedIn ? '/overview' : '/signup';
      },
    },
  };
</script>

<style lang="scss" scoped>
  .why-appoint-us-list {
    text-align: left;

    li {
      margin-bottom: 10px;
    }
  }

  .estate-admin-partner {
    margin: 40px auto 0 auto;
    border-radius: 10px;
  }
</style>
